import { Component, computed, inject } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PopupBannerComponent } from '../../components/popup-banner/popup-banner.component';
import { FomoTopBannerComponent } from './components/fomo-top-banner/fomo-top-banner.component';
import { FomoBottomBarComponent } from './components/fomo-bottom-bar/fomo-bottom-bar.component';

/**
 * 레이아웃 컴포넌트
 * @description daisyUI drawer 기반의 반응형 메인 레이아웃
 * @author OOO <your-email@lepisode.team>
 */
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    PopupBannerComponent,
    FomoTopBannerComponent,
    FomoBottomBarComponent,
  ],
})
export class LayoutComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  /**
   * Route data에서 mobileHeader 값 추출
   * mobileHeader가 true인 페이지는 자체 모바일 헤더가 있으므로
   * PC 헤더를 md 이상에서만 표시
   */
  private routeData = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null),
      map(() => this.getRouteData())
    ),
    { initialValue: {} }
  );

  private currentUrl = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null),
      map(() => this.router.url)
    ),
    { initialValue: this.router.url }
  );

  isHomePage = computed(() => this.currentUrl() === '/');

  // 홈: FOMO 배너(40px) 아래에 fixed, 다른 페이지: 최상단
  headerTopClass = computed(() => (this.isHomePage() ? 'top-10' : 'top-0'));

  hasMobileHeader = computed(() => {
    const data = this.routeData();
    return data && 'mobileHeader' in data && !!data['mobileHeader'];
  });

  private getRouteData(): Record<string, unknown> {
    try {
      let child = this.route.firstChild;
      while (child?.firstChild) {
        child = child.firstChild;
      }
      return child?.snapshot?.data ?? {};
    } catch {
      return {};
    }
  }
}
